import Modal from "react-bootstrap/Modal";

export default function ConnectionLost (props)
{
    return (
	<Modal
	    show={props.show}
	    backdrop="static"
	    keyboard={false}
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Problème de connexion</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		Communication avec le serveur impossible.
		Veuillez vérifier votre connection Internet.
	    </Modal.Body>
	</Modal>
    );
}
